import { createReducer } from '/@/store/utils';
import { isOffline, isOnline } from './actions';

export default createReducer(
    {
        offline: typeof window !== 'undefined' ? !window.navigator.onLine : false,
    },
    {
        [isOnline]: (state) => ({ ...state, offline: false }),
        [isOffline]: (state) => ({ ...state, offline: true }),
    }
);
